export default {
  response_code: 0,
  results: [
    {
      category: "General Knowledge",
      type: "multiple",
      difficulty: "easy",
      // question: "Which sign of the zodiac is represented by the Crab?",
      // correct_answer: "Cancer",
      // incorrect_answers: ["Libra", "Cancer", "Virgo", "Sagittarius"],
      question: "What is the capital of Pakistan?",
      correct_answer: "Islamabad",
      incorrect_answers: ["Lahore", "Karachi", "Peshawar", "Islamabad"],
    },
    {
      category: "General Knowledge",
      type: "multiple",
      difficulty: "easy",
      question: "What is the name of Poland in Polish?",
      correct_answer: "Polska",
      incorrect_answers: ["Pupcia", "Polska", "Polszka", "Poacuteland"],
    },
    {
      category: "General Knowledge",
      type: "multiple",
      difficulty: "easy",
      question:
        "What machine element is located in the center of fidget spinners?",
      correct_answer: "Bearings",
      incorrect_answers: ["Axles", "Gears", "Belts", "Bearings"],
    },
    {
      category: "General Knowledge",
      type: "multiple",
      difficulty: "easy",
      question: "Which sign of the zodiac comes between Virgo and Scorpio?",
      correct_answer: "Libra",
      incorrect_answers: ["Libra", "Gemini", "Taurus", "Capricorn"],
    },
    {
      category: "General Knowledge",
      type: "multiple",
      difficulty: "easy",
      question: "What company developed the vocaloid Hatsune Miku?",
      correct_answer: "Crypton Future Media",
      incorrect_answers: [
        "Sega",
        "Crypton Future Media",
        "Sony",
        "Yamaha Corporation",
      ],
    },
  ],
};
